var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('p',[_c('span',[_vm._v(_vm._s(_vm.value.length))]),(_vm.hasMax)?_c('span',[_vm._v(" / "+_vm._s(_vm.max))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }